import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebook, faLinkedin, faWhatsapp, faTelegram } from '@fortawesome/free-brands-svg-icons'
import {
  faChevronRight,
  faAngleRight,
  faCaretUp,
  faCaretDown,
  faCaretRight,
  faBars,
  faTimes,
  faChevronLeft,
  faChevronDown,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faChevronRight,
  faAngleRight,
  faCaretUp,
  faCaretDown,
  faBars,
  faTimes,
  faChevronLeft,
  faChevronDown,
  faCaretRight,
  faFacebook,
  faWhatsapp,
  faTelegram,
  faLinkedin,
)
